import React from "react";
import Navbar from "../widgets/Navbar";
import Footer from "../widgets/Footer";

const Fees = () => {
  return (
    <div>
      <Navbar />
       <section className="in_page p70 bg4">
              <div className="container"> 
                    <h1 className="hadding">Fees</h1>
                    <h2 >Transparent, Competitive Pricing</h2>
                    <p>No hidden fees - just clear, predictable pricing models tailored to your needs.</p> 
          <h3 className=" mb-2 mt-md-5">Trading Platform Fees</h3>
          
          <div className="table-responsive mb-5">
          <table className="table ">
            <tr>
              <th>Model </th>
              <th>Details </th>
            </tr>
            <tr>
              <td>Commission-Based </td>
              <td>From $0.02 per share; minimum $1.00 per order (equities)  </td>
            </tr>
             <tr>
              <td>Spread-Based  </td>
              <td>Variable spreads starting at 0.5 pips (FX)  </td>
            </tr>
             <tr>
              <td>Crypto Exchange Fees  </td>
              <td> Maker: 0.10% • Taker: 0.20% </td>
            </tr>
             <tr>
              <td>Derivatives & Futures  </td>
              <td>Exchange and clearing fees passed through, plus $0.50 per contract  </td>
            </tr> 
          </table> 
          </div>

            <h3 className=" mb-2">Copy Trading & Competitions</h3>
          
          <div className="table-responsive mb-5">
          <table className="table ">
            <tr>
              <th>Offering </th>
              <th>Fee Structure </th>
            </tr>
            <tr>
              <td>Copy Trading </td>
              <td>10% performance fee on net profits  </td>
            </tr>
              <tr>
              <td>Trading Competitions  </td>
              <td>Entry fees from $50; prize pools start at $5,000  </td>
            </tr>
            
          </table> 
          </div>

             <h3 className=" mb-3">Billing & Payments </h3>
            <ul className="list ">
                  <li> <b>  Payment Methods: </b>  Bank transfer, credit card, major cryptocurrencies.</li> 
                  <li> <b>  Invoicing: </b>   Monthly invoices for subscription and retainer services.</li> 
                </ul>
       
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Fees;
